import React, { useEffect, useState } from "react";
import Header from "./Header";
import { Link } from "react-router-dom";
import $ from "jquery";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import VideoSlider from "./VideoSlider";
import { API_V2_URL } from "./utils/bootstrap";
import axios from "axios";
import VideoPlayer from "./common/VideoPlayer";
import SharePopup from "./common/Sharepopup";
import { getDeviceType } from "./utils/Helper";
import Wisdom from "./Wisdom";

const Home = () => {
  const [activeTab, setActiveTab] = useState("student");
  const [lang, setLang] = useState("en");
  const [loadmore, setLoadmore] = useState(true);
  const [finalData, setFinalData] = useState([]);
  const [showVideosection, setShowVideoSection] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState("video");
  const [langu, setLangu] = useState({});
  const [link, setLink] = useState("");
  const [quote, setQuote] = useState("");
  const [twittermessage, setTwittermessage] = useState("");
  const [shareType, setShareType] = useState("");
  const [topics, setTopics] = useState("Topics");
  const [navbar, setNavbar] = useState(true);
  const [isVisible, setIsVisible] = useState(false);

  const english = {
    url: "https://vz-b2cb11d7-982.b-cdn.net/bfe9942b-c7ae-4606-a7f2-fc5cdf3778f6/playlist.m3u8",
    id: "tutorial",
    thumb:
      // "https://cdn.narendramodi.in/cmsuploads/0.70037400_1704782099_main-video-masterclass-thumbnail-english.jpg",
      "https://cdn.narendramodi.in/cmsuploads/0.59035600_1736347226_preview-en.jpg",
  };

  const hindi = {
    url: "https://vz-b2cb11d7-982.b-cdn.net/453c0bb4-c299-4579-b5bd-b338b6273028/playlist.m3u8",
    id: "tutorial",
    thumb:
      "https://cdn.narendramodi.in/cmsuploads/0.45723600_1736347285_preview-hi.jpg",
  };

  useEffect(() => {
    setLangu({});
    setTimeout(() => {
      if (lang == "hi") {
        setLangu(hindi);
      } else {
        setLangu(english);
      }
    }, 200);
  }, [lang]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  $(document).scroll(function () {
    if ($(window).scrollTop() >= 1000) {
      $(".head_stick").addClass("head_stick2");
    } else {
      $(".head_stick").removeClass("head_stick2");
    }
  });

  useEffect(() => {
    $(document).ready(function () {
      $(".cross_icon").click(function () {
        $(".topic_pos").hide();
      });
      $(".topic_select").click(function () {
        $(".topic_pos").show();
      });
    });
    setFinalData([]);
    fetchList();

    if (getDeviceType() == "mobile") {
      setNavbar(false);
    }
  }, [lang, activeTab]);

  // useEffect(() => {
  //   fetchList();
  // }, [lang, activeTab]);

  const showNavbar = () => {
    setNavbar(true);
  };
  const selectTab = (title) => {
    setTopics(title);
    if (getDeviceType() == "mobile") {
      setNavbar(false);
    }
  };

  const fetchList = async () => {
    console.log("lang", lang);
    setLoadmore(false);
    let response = await axios.get(
      `${API_V2_URL}&lang=${lang}&type=${activeTab}&index=${1}`
    );
    if (response.data) {
      let res = response.data;
      if (res._resultflag == 1) {
        // setNewData(res.data)
        // setData(res.data)
        setFinalData(res.data);
        setLoadmore(true);

        setTimeout(() => {
          setShowVideoSection(true);
        }, 3000);
      } else {
        setLoadmore(false);
      }
    }
  };

  const imageArray = finalData.map((item) => item.details.Image).flat();
  const videoArray = finalData.map((item) => item.details.Video).flat();
  const textArray = finalData.map((item) => item.details.Text).flat();
  const metaArray = finalData.map((item) => {
    const extractedDetails = {
      meta_id: item.id,
      meta_title: item.meta_title,
      meta_desc: item.meta_desc,
      share_text: item.share_text,
    };
    return extractedDetails;
  });

  const setInnerType = () => {
    $(".vjs-tech").each(function () {
      $(this).get(0).pause();
      $(this).attr("data-playpause", "1");
      $(".play_icon").attr("src", "/assets/images/play2.svg");
    });
  };

  const langChangeHandler = (e) => {
    setLang(e.target.value);
  };

  const playpause = (video_id, type) => {
    let playpausebtn = ".playpausebtn_" + video_id;
    $(".vjs-tech").each(function () {
      $(this).get(0).pause();
      $(".play_icon").attr("src", "/assets/images/play2.svg");
      if ($(this)[0].playerId != "myVideo_" + video_id) {
        $(this).attr("data-playpause", "1");
      }
    });
    let videoid = "myVideo_" + type + "_" + video_id + "_html5_api";

    let el = $("#" + videoid).get(0);
    let data_play = $("#" + videoid).attr("data-playpause");
    data_play = data_play ? data_play.toString() : data_play;

    if (data_play && data_play == 1) {
      $("#" + videoid).attr("data-playpause", "0");
      $(playpausebtn).attr("src", "/assets/images/pause.svg");
      $(playpausebtn).fadeOut();
      el.play();
    } else if (!data_play) {
      $("#" + videoid).attr("data-playpause", "0");
      $(playpausebtn).attr("src", "/assets/images/pause.svg");
      el.play();
      $(playpausebtn).fadeOut();
      // $('.videoplay_icon').show();
    } else {
      $("#" + videoid).attr("data-playpause", "1");
      $(playpausebtn).attr("src", "/assets/images/play2.svg");
      el.pause();
      $(playpausebtn).fadeIn();
      // $('.videoplay_icon').show();
    }
  };

  const hideplayIcon = (video_id, type) => {
    let timeout = null;
    if (timeout) {
      clearTimeout(timeout);
    }
    let playpausebtn = ".playpausebtn_" + video_id;

    let videoid = "myVideo_" + video_id + "_html5_api";
    let data_play = $("#" + videoid).attr("data-playpause");
    if (data_play == 0) {
      timeout = setTimeout(() => {
        $(playpausebtn).fadeOut();
      }, 500);
    } else {
      $(playpausebtn).fadeIn();
    }
  };

  const handlePlayerReady = (player) => {
    // you can handle player events here
    player.on("waiting", () => {
      console.log("player is waiting");
    });
    player.on("play", () => {
      $(".videoplay_icon").hide();
      // console.log('playing');F
    });
    player.on("dispose", () => {
      console.log("player will dispose");
    });
  };

  const handleTopicClick = (id) => {
    // Yaha par aap id ke basis pe selected topic ko set kar sakte hain
    setSelectedTopic(id);
  };

  const share = (id, share_text, type = "detail") => {
    $(".popup_fixed_bg").show();
    let params = type == "topic" ? `topic/${id}` : id;
    let link = `https://www.narendramodi.in/parikshapecharcha/${params}`;
    setLink(link);
    setQuote(share_text);
    setTwittermessage(share_text);
    setShareType(type);
  };

  $(document).scroll(function () {
    if ($(window).scrollTop() >= 1500) {
      $(".arrowup").addClass("arrowup2");
    } else {
      $(".arrowup").removeClass("arrowup2");
    }
  });

  const backbutton = () => {
    $(".topic_pos").hide();
  };

  var language = lang;
  const params = new URLSearchParams(window.location.search);

  console.log("navbar", navbar);
  return (
    <>
      <Header
        langu={langu}
        // playpause={playpause}
        // hideplayIcon={hideplayIcon}
        // handlePlayerReady={handlePlayerReady}
        langChangeHandler={langChangeHandler}
        language={language}
      />

      <a id="gototop" className="arrowup" href="#">
        <img src="/assets/images/chevroncircle.svg" alt="" />
      </a>
      <section className="ppcques_sec">
        <div className="container-fluid">
          <Wisdom
            langu={langu}
            playpause={playpause}
            hideplayIcon={hideplayIcon}
            handlePlayerReady={handlePlayerReady}
            langChangeHandler={langChangeHandler}
            language={language}
          />

          <div className="questio_pad">
            <img
              src="/assets/images/rabbitquestion.jpg"
              className="rabbit_qust_img img-fluid"
              alt=""
            />
            {/* <video autoPlay muted playsInline loop className="video_drone">
              <source src="/assets/images/girlddrone.mp4" type="video/mp4" />
            </video>

            <video autoPlay muted playsInline loop className="rabbit_an">
              <source
                src="/assets/images/rabbitanimation.mp4"
                type="video/mp4"
              />
            </video> */}
          </div>
        </div>

        <div className="head_stick">
          <ul className="stud_tab">
            <li>
              <Link
                to=""
                className={activeTab === "student" ? "active" : ""}
                onClick={() => handleTabClick("student")}
              >
                Student
              </Link>
            </li>
            <li>
              <Link
                to=""
                className={activeTab === "parent" ? "active" : ""}
                onClick={() => handleTabClick("parent")}
              >
                Parent
              </Link>
            </li>
            <li>
              <Link
                to=""
                className={activeTab === "teacher" ? "active" : ""}
                onClick={() => handleTabClick("teacher")}
              >
                Teacher
              </Link>
            </li>
          </ul>
          <ul className="nav nav-tabs nav_cus_tab" role="tablist">
            <li className="nav-item">
              <a
                onClick={() => handleTopicClick("video")}
                className="nav-link active"
                data-toggle="tab"
                href="#video"
              >
                Video
              </a>
            </li>
            <li className="nav-item">
              <a
                onClick={() => handleTopicClick("image")}
                className="nav-link"
                data-toggle="tab"
                href="#image"
              >
                Image
              </a>
            </li>
            <li className="nav-item">
              <a
                onClick={() => handleTopicClick("text")}
                className="nav-link"
                data-toggle="tab"
                href="#text"
              >
                Text
              </a>
            </li>
          </ul>
        </div>

        <div className="container-fluid">
          <div className="questio_pad">
            <div className="row row_wid">
              <div className="col-sm-3 topic_index">
                <div className="topic_select" onClick={() => showNavbar()}>
                  <p className="topic_head2">
                    {lang == "en" ? <>Topics</> : <>विषय</>}
                    <img
                      src="/assets/images/chevrondwon.svg"
                      className=""
                      alt=""
                    />
                  </p>
                </div>

                <div
                  className="topic_pos"
                  style={navbar ? { display: "block" } : { display: "none" }}
                >
                  <div className="topic_head">
                    <button className="crosstopic" onClick={() => backbutton()}>
                      <img
                        src="/assets/images/crossorange.svg"
                        className=""
                        alt=""
                      />
                    </button>
                    <h4>{lang == "en" ? <>Topics</> : <>विषय</>}</h4>
                    <div className="desk_set">
                      <nav id="myScrollspy">
                        <span className="fa fa-times cross_icon"></span>
                        <ul className="navbar-nav topic_list">
                          {finalData &&
                            finalData.map((val, index) => {
                              let indexval = index + 1;
                              return (
                                <li className="nav-item" key={index}>
                                  <a
                                    onClick={() => selectTab(val.title)}
                                    className="nav-link"
                                    href={`#topic-${val.id}`}
                                    // href={vid}
                                  >
                                    <span className="topic_no">{`#${indexval}`}</span>
                                    <span className="topic_name">
                                      {val.title}
                                    </span>
                                  </a>
                                </li>
                              );
                            })}
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-9 topi_pos">
                <div className="tab-content">
                  {selectedTopic === "video" && (
                    <div className="tab-pane active" id="video">
                      {videoArray &&
                        videoArray.map((el, index) => {
                          let i = index + 1;

                          return (
                            <div
                              id={`topic-${el.parentid}`}
                              className="topic_con"
                            >
                              <h5>
                                {lang == "en" ? <>#Topic</> : <>#विषय</>} {i}
                              </h5>
                              <h4>{el.title}</h4>
                              <ul className="exam_gallery">
                                <li>
                                  {/* <img
                                    src="/assets/images/img-1.jpg"
                                    className=""
                                    alt=""
                                  /> */}
                                  <div className="video_tab">
                                    <VideoPlayer
                                      onReady={handlePlayerReady}
                                      id={el.id}
                                      keyi={el.id}
                                      key={el.id}
                                      type="long"
                                      video_url={el.video_url}
                                      thumb={el.thumb_url}
                                    />
                                    <span
                                      className="play_layer"
                                      onClick={() => {
                                        playpause(el.id, "long");
                                      }}
                                      onMouseMove={() => {
                                        hideplayIcon(el.id, "long");
                                      }}
                                    >
                                      <img
                                        src="/assets/images/play2.svg"
                                        className={
                                          "play_icon playpausebtn_" + el.id
                                        }
                                        alt=""
                                      />
                                    </span>
                                    <span
                                      className="main_play"
                                      onClick={() => {
                                        playpause(el.id, "long");
                                      }}
                                    ></span>
                                  </div>
                                </li>
                              </ul>

                              <ul className="share_list">
                                <li>
                                  <button
                                    onClick={() =>
                                      share(el.id, el.share_text, "youtube")
                                    }
                                  >
                                    <img
                                      src="/assets/images/shareorange.svg"
                                      className="sh_or"
                                      alt=""
                                    />
                                    <img
                                      src="/assets/images/sharewhite.svg"
                                      className="sh_wh"
                                      alt=""
                                    />
                                    {lang == "en" ? (
                                      <>Share Video</>
                                    ) : (
                                      <>वीडियो साझा करें</>
                                    )}
                                  </button>
                                </li>
                                <li>
                                  <button
                                    onClick={() =>
                                      share(el.parentid, el.share_text, "topic")
                                    }
                                  >
                                    <img
                                      src="/assets/images/shareorange.svg"
                                      className="sh_or"
                                      alt=""
                                    />
                                    <img
                                      src="/assets/images/sharewhite.svg"
                                      className="sh_wh"
                                      alt=""
                                    />
                                    {lang == "en" ? (
                                      <>Share Topic</>
                                    ) : (
                                      <>विषय साझा करें</>
                                    )}
                                  </button>
                                </li>
                              </ul>
                            </div>
                          );
                        })}
                    </div>
                  )}
                  {selectedTopic === "image" && (
                    <div className="tab-pane fade" id="image">
                      {imageArray &&
                        imageArray.map((image, index) => {
                          let i = index + 1;
                          return (
                            <div
                              id={`topic-${image.parentid}`}
                              className="topic_con"
                            >
                              <h5>
                                {lang == "en" ? <>#Topic</> : <>#विषय</>} {i}
                              </h5>
                              <h4>{image.title}</h4>
                              <ul className="exam_gallery">
                                <li>
                                  <img
                                    src={image.url}
                                    className="image_size"
                                    alt=""
                                  />
                                </li>
                              </ul>

                              <ul className="share_list">
                                <li>
                                  <button
                                    onClick={() =>
                                      share(
                                        image.id,
                                        image.share_text,
                                        "youtube"
                                      )
                                    }
                                  >
                                    <img
                                      src="/assets/images/shareorange.svg"
                                      className="sh_or"
                                      alt=""
                                    />
                                    <img
                                      src="/assets/images/sharewhite.svg"
                                      className="sh_wh"
                                      alt=""
                                    />
                                    {lang == "en" ? (
                                      <>Share Image</>
                                    ) : (
                                      <>इमेज साझा करें</>
                                    )}
                                  </button>
                                </li>
                                <li>
                                  <button
                                    onClick={() =>
                                      share(
                                        image.parentid,
                                        image.share_text,
                                        "topic"
                                      )
                                    }
                                  >
                                    <img
                                      src="/assets/images/shareorange.svg"
                                      className="sh_or"
                                      alt=""
                                    />
                                    <img
                                      src="/assets/images/sharewhite.svg"
                                      className="sh_wh"
                                      alt=""
                                    />
                                    {lang == "en" ? (
                                      <>Share Topic</>
                                    ) : (
                                      <>विषय साझा करें</>
                                    )}
                                  </button>
                                </li>
                              </ul>
                            </div>
                          );
                        })}
                    </div>
                  )}
                  {selectedTopic === "text" && (
                    <div className="tab-pane fade" id="text">
                      {textArray &&
                        textArray.map((text, index) => {
                          let i = index + 1;
                          return (
                            <div
                              id={`topic-${text.parentid}`}
                              className="topic_con"
                            >
                              <h5>
                                {lang == "en" ? <>#Topic</> : <>#विषय</>} {i}
                              </h5>
                              <h4>{text.title}</h4>
                              <div className="topictext_div">
                                <div className="topic_textbg">
                                  <PerfectScrollbar>
                                    <div className="topic_text_content">
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html: text.description,
                                        }}
                                      ></p>
                                    </div>
                                  </PerfectScrollbar>
                                </div>
                              </div>

                              <ul className="share_list">
                                <li>
                                  <button
                                    onClick={() =>
                                      share(
                                        text.parentid,
                                        text.share_text,
                                        "topic"
                                      )
                                    }
                                  >
                                    <img
                                      src="/assets/images/shareorange.svg"
                                      className="sh_or"
                                      alt=""
                                    />
                                    <img
                                      src="/assets/images/sharewhite.svg"
                                      className="sh_wh"
                                      alt=""
                                    />
                                    {lang == "en" ? (
                                      <>Share Topic</>
                                    ) : (
                                      <>विषय साझा करें</>
                                    )}
                                  </button>
                                </li>
                                <li>
                                  <Link
                                    // to={lang + `/topic/` + text.id}
                                    to={
                                      lang == "en"
                                        ? window.location.href.indexOf(
                                            "appversion"
                                          ) != -1
                                          ? `/en/${text.id}?` + params
                                          : "https://www.narendramodi.in/parikshapecharcha/" +
                                            text.id
                                        : window.location.href.indexOf(
                                            "appversion"
                                          ) != -1
                                        ? `/${lang}/${text.id}`
                                        : "https://www.narendramodi.in/" +
                                          lang +
                                          "/parikshapecharcha/" +
                                          text.id
                                    }
                                    target={
                                      window.location.href.indexOf(
                                        "appversion"
                                      ) != -1
                                        ? "_parent"
                                        : "_blank"
                                    }
                                  >
                                    <img
                                      src="/assets/images/readorange.png"
                                      className="sh_or read"
                                      alt=""
                                    />
                                    <img
                                      src="/assets/images/read.png"
                                      className="sh_wh read"
                                      alt=""
                                    />
                                    {lang == "en" ? (
                                      <>Read More</>
                                    ) : (
                                      <>अधिक पढ़ें</>
                                    )}
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          );
                        })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <SharePopup
          link={link}
          quote={quote}
          twittermessage={twittermessage}
          shareType={shareType}
        />
      </section>

      {/* <VideoSlider /> */}
    </>
  );
};

export default Home;
